/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Stcolrate2Inputs */

const zh_landing_admin_stcolrate2 = /** @type {(inputs: Landing_Admin_Stcolrate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成率`)
};

const en_landing_admin_stcolrate2 = /** @type {(inputs: Landing_Admin_Stcolrate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finish rate`)
};

const es_landing_admin_stcolrate2 = /** @type {(inputs: Landing_Admin_Stcolrate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasa de finalización`)
};

/**
* | output |
* | --- |
* | "Finish rate" |
*
* @param {Landing_Admin_Stcolrate2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_admin_stcolrate2 = /** @type {((inputs?: Landing_Admin_Stcolrate2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Stcolrate2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_stcolrate2(inputs)
	if (locale === "en") return en_landing_admin_stcolrate2(inputs)
	return es_landing_admin_stcolrate2(inputs)
});
export { landing_admin_stcolrate2 as "landing_admin_stColRate" }